import { useState } from "react";
import { SignOut } from "@phosphor-icons/react";
import { Button } from "../components/ui/button";
import { useAuth } from "../contextos/AuthContext";
import DialogConfirmacao from "./DialogConfirmacao";

// BotaoSair: ícone de sair com confirmação por popup.
// Pode ser usado no header de qualquer página.
export default function BotaoSair() {
    const { sair } = useAuth();
    const [confirmando, setConfirmando] = useState(false);

    return (
        <>
            <Button
                size="sm"
                variant="outline"
                data-testid="btn-sair-header"
                title="Sair"
                onClick={() => setConfirmando(true)}
                className="bg-transparent border-zinc-800 hover:bg-zinc-900 text-zinc-400 hover:text-red-400"
            >
                <SignOut size={14} weight="bold" />
            </Button>

            <DialogConfirmacao
                aberto={confirmando}
                setAberto={setConfirmando}
                titulo="Sair do painel?"
                descricao="Você será desconectado e voltará para a tela de login. Suas sessões de navegador permanecerão ativas no servidor."
                rotuloAcao="Sair"
                destrutivo={false}
                onConfirmar={sair}
                testId="dialog-sair"
            />
        </>
    );
}
